<div class="post-section bg-light section-gap">
  <div class="container">
    <div class="section-title-wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-10 mx-auto text-center">
          <div class="d-flex align-items-center justify-content-center">
            <app-badges [badges]="config.badges"></app-badges>
          </div>
          <div class="d-flex align-items-center">
            <h3 [id]="config.title | stripSpecialChars">
              {{config.title}}
            </h3>
            <kla-social-media-buttons class="mb-2" [linkFragment]="config.title"></kla-social-media-buttons>
          </div>

          <app-dynamic-content
            [contentId]="'tile-collection-desc'"
            [htmlContent]="config.description">
          </app-dynamic-content>
        </div>
      </div>
    </div>
    <div class="card-deck">
      <div class="row w-100" angly-postGrid [postGridContent]="config.list"></div>
    </div>
  </div>
</div>
